import { cache } from '@/container/apollo-client/cache';
import { GetUserOnlineStatusQuery, UserWorkspace } from '@/types/generated/graphql';
import { gql } from '@apollo/client';

const USER_FRAGMENT = gql`
  fragment MYSELF on WorkspaceMembers {
    userOnlineManagement
  }
`;
export function updateMyAwayStatus(
  currentUserWorkspace: UserWorkspace | null | undefined,
  userStatusData: GetUserOnlineStatusQuery | undefined
) {
  const { activeStatus, awayTill, icon, message } = userStatusData?.getUserOnlineStatus?.data || {};
  cache.writeFragment({
    id: 'WorkspaceMembers:' + currentUserWorkspace?.id,
    fragment: USER_FRAGMENT,
    data: {
      userOnlineManagement: {
        activeStatus,
        awayTill,
        icon,
        isActive: activeStatus === 'active',
        lastSeenAt: new Date().toISOString(),
        message,
      },
    },
  });
}
